/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ClientCaseIssueType {
  AwaitingPayment = 'AwaitingPayment',
  AwaitingFormResponse = 'AwaitingFormResponse',
  UnreadMessages = 'UnreadMessages',
  NewIncoming = 'NewIncoming'
}
